import { t as tx } from '@/i18n';
import { cn } from '@/shared/lib/utils';

/**
 * The Netxol mark (official artwork, public/brand): black frame + blue blades on light backgrounds, white frame + blue
 * blades on dark or coloured ones. `tone` forces one ("dark" = the background is dark); by default it follows the theme.
 */
export function NetxolMark({ className, tone = 'auto' }: { className?: string; tone?: 'auto' | 'light' | 'dark' }) {
  const alt = tx('pg.shared_netxollogo.netxol');
  const cls = cn('h-5 w-auto shrink-0 select-none', className);
  if (tone === 'light') return <img src="/brand/netxol-mark.png" alt={alt} className={cls} draggable={false} />;
  if (tone === 'dark') return <img src="/brand/netxol-mark-on-dark.png" alt={alt} className={cls} draggable={false} />;
  return (
    <>
      <img src="/brand/netxol-mark.png" alt={alt} className={cn(cls, 'dark:hidden')} draggable={false} />
      <img src="/brand/netxol-mark-on-dark.png" alt={alt} className={cn(cls, 'hidden dark:block')} draggable={false} />
    </>
  );
}

export function NetxolLogo({ compact = false, className }: { compact?: boolean; className?: string }) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <NetxolMark className="h-7" />
      {!compact && (
        <div className="flex min-w-0 flex-col leading-none">
          <div className="text-[15px] font-bold tracking-tight">{tx('pg.shared_netxollogo.netxol')} <span className="text-primary">{tx('pg.shared_netxollogo.one')}</span></div>
          <div className="mt-1 text-[10px] font-medium uppercase tracking-[0.14em] text-muted-foreground">{tx('pg.shared_netxollogo.isp_operating_system')}</div>
        </div>
      )}
    </div>
  );
}
